<template>
  <NewCustomModal :visible="showModal" size="large" @close="closeModal">
    <div class="popup-container">
      <!-- Title -->
      <h2 class="popup-title">Kenapa Harus Efunding?</h2>

      <!-- Benefits Grid -->
      <div class="benefits-grid">
        <div
          v-for="(benefit, idx) in benefits"
          :key="idx"
          class="benefit-item-container"
        >
          <div class="benefit-item">
            <span class="icon-check">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <circle cx="11" cy="11" r="11" fill="#13346C" />
                <path
                  d="M7 11.5L10 14.5L15 9.5"
                  stroke="#FFC72C"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="benefit-text">{{ benefit }}</span>
          </div>
        </div>
      </div>

      <!-- CTA Button -->
      <button @click="AjukanSekarang" class="cta-button">
        Ajukan Sekarang!
      </button>

      <div class="checkbox-container">
        <label class="checkbox-label">
          <input
            type="checkbox"
            v-model="dontShowAgain"
            class="checkbox-input"
          />
          <span class="checkbox-custom"></span>
          <span class="checkbox-text">Jangan tampilkan popup ini lagi</span>
        </label>
      </div>
    </div>
  </NewCustomModal>
</template>

<script>
import NewCustomModal from "./newCustomModal.vue";

export default {
  name: "PopUpCTA",
  components: {
    NewCustomModal,
  },
  data() {
    return {
      showModal: false,
      dontShowAgain: false,
      benefits: [
        "Murni Syariah",
        "Pilihan Produk Beragam",
        "Praktis dan 100% Online",
        "Aman dan Diawasi OJK",
        "Bebas Biaya Platform",
        "Imbal Hasil Kompetitif",
      ],
    };
  },
  methods: {
    AjukanSekarang() {
      this.handleModalClose();
      this.$router.push("/layanan-kami");
    },
    closeModal() {
      this.handleModalClose();
    },
    checkShouldShowModal() {
      const dismissed = localStorage.getItem("efundingPopupDismissed");
      if (!dismissed) {
        this.showModal = true;
      }
    },
    handleModalClose() {
      if (this.dontShowAgain) {
        localStorage.setItem("efundingPopupDismissed", "true");
      }
      this.showModal = false;
    },
    handleEsc(event) {
      if (event.key === "Escape") {
        this.closeModal();
      }
    },
  },
  mounted() {
    // Cek apakah popup harus ditampilkan saat component dimount
    this.checkShouldShowModal();
    window.addEventListener("keydown", this.handleEsc);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleEsc);
  },
};
</script>

<style scoped>
.popup-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.popup-title {
  font-size: 1.5rem;
  line-height: 1.3;
  font-weight: 700;
  color: #13346c;
  margin-bottom: 1.5rem;
}

.benefits-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  margin-bottom: 2rem;
  text-align: center;
}

@media (min-width: 768px) {
  .benefits-grid {
    grid-template-columns: 1fr 1fr;
    width: 80%;
    gap: 1rem;
    text-align: center;
  }
  .popup-title {
    font-size: 1.875rem;
  }
}
.benefit-item-container {
  display: flex;
  justify-content: center;
}

.benefit-item {
  display: flex;
  width: 275px;
  align-items: center;
  background-color: #ffc72c;
  color: #13346c;
  font-weight: 700;
  border-radius: 1px 9999px 9999px;
  padding: 0.75rem 1rem;
  gap: 0.5rem;
  box-shadow: 0 2px 6px rgba(19, 52, 108, 0.1);
  transition: background 0.2s, transform 0.2s;
}

.benefit-item:hover {
  background-color: #f5b700;
  transform: translateY(-2px);
}

.icon-check {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.benefit-text {
  font-weight: 700;
  color: #13346c;
  font-size: 0.95rem;
}

.cta-button {
  background-color: #13346c;
  color: white;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  transition: background-color 0.3s, transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(19, 52, 108, 0.2);
}

.cta-button:hover {
  background-color: #0f2a52;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(19, 52, 108, 0.3);
}

.checkbox-container {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #666;
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #13346c;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  position: relative;
}

.checkbox-input:checked + .checkbox-custom {
  background-color: #13346c;
  border-color: #13346c;
}

.checkbox-input:checked + .checkbox-custom::after {
  content: "";
  width: 4px;
  height: 8px;
  border: solid #ffc72c;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  position: absolute;
  top: 1px;
  left: 5px;
}

.checkbox-text {
  user-select: none;
  font-weight: 500;
}

.checkbox-label:hover .checkbox-custom {
  border-color: #0f2a52;
}
</style>



// WEBPACK FOOTER //
// src/components/PopUpCTA.vue